/**
 * @file global data store
 * @author douwencan(douwencan1994@163.com)
 */

const state = {
  /**
   * 公众号二维码
   *
   * @type {string}
   */
  qrCode: '',

  /**
   * banner
   *
   * @type {string}
   */
  banner: '',

  /**
   * 是否需要关注
   *
   * @type {boolean}
   */
  needSubscribe: true,

  /**
   * 用户昵称
   *
   * @type {string}
   */
  nickname: '',

  /**
   * 用户头像
   *
   * @type {string}
   */
  avatar: '',

  /**
   * 用户是否关注了公众号
   *
   * @type {boolean}
   */
  hasSubscribe: true,

  // idUserName: '',
  // idGender: '',
  // idBirthday: '',
  // idNo: '',
  // idAddress: '',
  // idCertExpiryDate: '',
  // idCertOriginDate: '',
  // idIssuingAuthority: '',
  // idNationality: ''
  idInfo: {}
}

const mutations = {
  setQrCode(state, qrCode) {
    state.qrCode = qrCode
  },
  setBanner(state, banner) {
    state.banner = banner
  },
  setNeedSubscribe(state, needSubscribe) {
    state.needSubscribe = needSubscribe
  },
  setNickname(state, nickname) {
    state.nickname = nickname
  },
  setAvatar(state, avatar) {
    state.avatar = avatar
  },
  setHasSubscribe(state, hasSubscribe) {
    state.hasSubscribe = hasSubscribe
  },
  setIdInfo(state, idInfo) {
    state.idInfo = idInfo
  }
  // setIdGender (state, idGender) {
  //   state.idGender = idGender
  // },
  // setIdBirthday (state, idBirthday) {
  //   state.idBirthday = idBirthday
  // },
  // setIdNo (state, idNo) {
  //   state.idNo = idNo
  // },
  // setIdAddress (state, idAddress) {
  //   state.idAddress = idAddress
  // },
  // setIdCertExpiryDate (state, idCertExpiryDate) {
  //   state.idCertExpiryDate = idCertExpiryDate
  // },
  // setIdCertOriginDate (state, idCertOriginDate) {
  //   state.idCertOriginDate = idCertOriginDate
  // },
  // setIdIssuingAuthority (state, idIssuingAuthority) {
  //   state.idIssuingAuthority = idIssuingAuthority
  // },
  // setIdNationality (state, idNationality) {
  //   state.idNationality = idNationality
  // }
}
export default {
  namespaced: true,
  /* eslint-disable */
  mutations,
  state
}
